import {
  FETCH_EVENT_CATEGORIES_ASYNC_START,
  FETCH_EVENT_CATEGORIES_ASYNC_END,
  FETCH_EVENT_CATEGORIES_SUCCESS,
} from '../actions/actions'

// const defaultState = {
//   isLoading: false,
//   list: [],
// },

export default function eventCategories(state = {}, action) {
  switch (action.type) {
    case FETCH_EVENT_CATEGORIES_ASYNC_START:
      return { ...state, isLoading: true }

    case FETCH_EVENT_CATEGORIES_ASYNC_END:
      return { ...state, isLoading: false }

    case FETCH_EVENT_CATEGORIES_SUCCESS:
      return { ...state, list: action.eventCategories || [] }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/eventCategories.js